import * as React from "react";
function fixedIntegerBitNumber(value, bit = 2) {
    if (typeof value === "number") {
        value = `${value}`;
    }
    let added = [];
    for (let i = 0; i < bit - value.length; i++) {
        added.push(0);
    }
    return `${added.join("")}${value}`;
}
function secToStr(seconds) {
    if (seconds <= 0) {
        return "00:00:00";
    }
    return `${fixedIntegerBitNumber(Math.floor(seconds / 3600))}:${fixedIntegerBitNumber(Math.floor((seconds % 3600) / 60))}:${fixedIntegerBitNumber((seconds % 3600) % 60)}`;
}
export default class TimeReduce extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            time: 0,
        };
        this.endTimer = 0;
    }
    componentDidMount() {
        const { time } = this.props;
        this.setState({
            time,
        });
        this.endTimer = window.setInterval(() => {
            let { time } = this.state;
            time -= 1;
            if (time >= 0) {
                this.setState({ time });
            }
            else {
                window.clearInterval(this.endTimer);
            }
        }, 1000);
    }
    componentWillUnmount() {
        window.clearInterval(this.endTimer);
    }
    render() {
        const { className } = this.props;
        return React.createElement("span", { className: className }, secToStr(this.state.time));
    }
}
